// extracted by mini-css-extract-plugin
export default {"leftNavigation":"CarouselLeft_leftNavigation__BMWJT"};